
import { defineComponent, ref, inject, computed, provide } from 'vue'
import FormService from '@/core/services/FormService'
import { errManager, DownloadXLSXPDF, mbtoa } from "@/core/config/Tools";

import DialogForms from '@/views/tournaments/pages/DialogForms.vue';

export default defineComponent({
    name: "acrd-dialog-list-clubs",
    props: {
        itemForm: {
            type: null,
            required: true,
            default: {}
        }
    },
    components: { DialogForms },
    setup(props) {
        const altura = screen.height;
        const loading = ref(false)
        const dialogListClubs = inject("dialogListClubs")
        const search = ref("")
        const listInstitutions = ref<any>([])
        const listSports = ref<any>([])
        const dialogForm = ref(false)
        const idinstitution = ref<any>("")

        provide("dialogForm", dialogForm)
        provide("idinstitution", idinstitution)

        const getListInstitutions = async () => {
            loading.value = true
            await FormService.options('institutions', props.itemForm)
                .then((res) => {
                    listInstitutions.value = res.data.clubs
                    listSports.value = res.data.sports
                    loading.value = false
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        // Función para verificar si el deporte está en la lista de seleccionados
        const isSelected = (idsport: any, list: any[]): boolean => {
            return list.some(selected => selected.idsport === idsport);
        };

        const filteredClubs = computed(() => {
            const query = search.value.toLowerCase();
            return listInstitutions.value.filter(
                item => {
                    const abrevMatches = item.abrev ? item.abrev.toLowerCase().includes(query) : false;
                    const businessMatches = item.business.toLowerCase().includes(query);
                    return abrevMatches || businessMatches;
                }
            );
        });

        const calculateTotal = (sports: any[]) => {
            // Logic to calculate total, for example counting selected sports
            return sports.length; // Example: return the number of selected sports
        };

        /*
        const getSumForSport = (sportId: number) => {
            return listInstitutions.value.reduce((sum, club) => sum + (isSelected(sportId, club.sports) ? 1 : 0), 0);
        };

        const getGrandTotal = () => {
            return listInstitutions.value.reduce((sum, club) => sum + calculateTotal(club.sports), 0);
        };
        */

        const onOpened = () => {
            getListInstitutions();
        }

        const onClosed = () => {
            listInstitutions.value = []
            listSports.value = []
        }

        const openDialogForm = (data) => {
            dialogForm.value = true
            idinstitution.value = data
        }

        const modalClosed = () => {
            getListInstitutions()
        }



        return {
            altura,
            loading,
            dialogListClubs,
            search,
            listInstitutions,
            listSports,
            onOpened,
            onClosed,
            isSelected,
            filteredClubs,
            openDialogForm,
            modalClosed,
            DownloadXLSXPDF,
            mbtoa,
            calculateTotal,
            //getSumForSport,
            //getGrandTotal
        }

    },
})
